import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 px-4 sm:px-6 bg-petrol text-white border-t-8 border-gold text-center" data-id="element-47">
      <p className="text-sm font-body font-bold text-gold uppercase tracking-widest mb-4" data-id="element-48">
        ONE LAST CHANCE
      </p>

      <div className="max-w-3xl mx-auto mb-10" data-id="element-49">
        <p className="text-xl sm:text-2xl font-subheading font-bold mb-6 leading-relaxed" data-id="element-50">
          Your participants deserve more than improvised sessions.
        </p>

        <div className="text-base sm:text-lg text-ivory/90 leading-relaxed space-y-4 mb-8" data-id="element-51">
          <p data-id="element-52">Stop spending hours planning.</p>
          <p data-id="element-53">Stop second-guessing your class structure.</p>
          <p data-id="element-54">
            Stop worrying about whether you're providing enough progression.
          </p>
          <p className="font-bold text-gold text-xl mt-6" data-id="element-55">
            Give your participants the safe, engaging, and professional
            experience they deserve.
          </p>
        </div>
      </div>

      <div className="bg-petrol-dark border border-gold/30 rounded-xl p-6 mb-8 shadow-2xl max-w-md mx-auto" data-id="element-56">
        <p className="text-sm sm:text-base font-bold mb-2 uppercase tracking-widest text-ivory" data-id="element-57">
          Pack 6-in-1: FITNESS SENIOR READY™ + 5 Premium Bonuses
        </p>
        <p className="text-lg line-through text-ivory/50 mb-1" data-id="element-58">$97 USD</p>
        <p className="text-5xl font-heading font-bold text-gold leading-none" data-id="element-59">
          Only: $27 USD
        </p>
      </div>

      <a href="#pricing" className="block cursor-pointer mb-8" data-id="element-60">
        <img src="https://cdn.magicpatterns.com/uploads/3BY8BrEsHe6M5N1YF9C6Vd/ChatGPT-Image-16-jun-2026_-15_07_04.webp" alt="FITNESS SENIOR READY 6-in-1 Box Set" className="w-full max-w-[240px] mx-auto object-contain drop-shadow-2xl" data-id="element-61" />
      </a>

      <div className="mb-6 max-w-lg mx-auto" data-id="element-62">
        <CTAButton href="#pricing" className="!bg-gold !text-petrol border-none shadow-[0_4px_14px_0_rgba(199,169,107,0.39)] hover:shadow-[0_6px_20px_rgba(199,169,107,0.23)] hover:!bg-gold/90" data-id="element-63">
          🚀 YES, I WANT MY FITNESS SENIOR READY™ PACK
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6 text-xs sm:text-sm font-bold text-ivory/80" data-id="element-64">
        <div className="flex items-center gap-2" data-id="element-65">
          <Zap className="w-4 h-4 text-gold" data-id="element-66" />
          <span data-id="element-67">Immediate Access — Delivered by Email</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-68">
          <Star className="w-4 h-4 fill-gold text-gold" data-id="element-69" />
          <span data-id="element-70">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-71">
          <ShieldCheck className="w-4 h-4 text-sage" data-id="element-72" />
          <span data-id="element-73">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}